module.exports = __webpack_public_path__ + "static/media/up.31fa092d.svg";